import type { Feedback } from '@/pages/dsst/dsstConfig';

interface NumberPadProps {
  onSelect: (n: number) => void;
  selectedNumber: number | null;
  feedback: Feedback;
  disabled: boolean;
  order?: number[];
}

export default function NumberPad({
  onSelect,
  selectedNumber,
  feedback,
  disabled,
  order,
}: NumberPadProps) {
  const numbers = order ?? [1, 2, 3, 4, 5, 6];
  return (
    <div className="w-full grid grid-cols-6 gap-2">
      {numbers.map((n) => {
        const isSelected = selectedNumber === n;
        const stateClass = isSelected
          ? feedback === 'correct'
            ? 'bg-primary-500 border-primary-500 text-white scale-105'
            : 'bg-secondary-600 border-secondary-600 text-white scale-105'
          : 'bg-white border-secondary-300 text-foreground-800 hover:border-primary-300';
        return (
          <button
            key={n}
            onClick={() => onSelect(n)}
            disabled={disabled}
            className={`aspect-square rounded-xl border-2 flex items-center justify-center
              text-xl font-bold select-none transition-all duration-150 whitespace-nowrap
              cursor-pointer active:scale-95 ${stateClass}`}
            aria-label={`숫자 ${n}`}
          >
            {n}
          </button>
        );
      })}
    </div>
  );
}